import { render, staticRenderFns } from "./BackLinkView.vue?vue&type=template&id=1253ea0e&"
import script from "./BackLinkView.vue?vue&type=script&lang=js&"
export * from "./BackLinkView.vue?vue&type=script&lang=js&"
import style0 from "./BackLinkView.vue?vue&type=style&index=0&id=1253ea0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports